import { ca } from '@cian/analytics';
const debounce = require('lodash/debounce');

export const trackBetChange = debounce(() => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Auction_block',
    action: 'Change_bid',
  });
}, 1000);
